"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollUp;

var _react = require("react");

var _useScrollRelative = _interopRequireDefault(require("./internal/useScrollRelative"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollUp() {
  var scrollRelative = (0, _useScrollRelative.default)();
  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollRelative.apply(void 0, ['up'].concat(args));
  }, [scrollRelative]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTY3JvbGxVcC50cyJdLCJuYW1lcyI6WyJ1c2VTY3JvbGxVcCIsInNjcm9sbFJlbGF0aXZlIiwiYXJncyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsV0FBVCxHQUFxRTtBQUNsRixNQUFNQyxjQUFjLEdBQUcsaUNBQXZCO0FBRUEsU0FBTyx3QkFBWTtBQUFBLHNDQUFJQyxJQUFKO0FBQUlBLE1BQUFBLElBQUo7QUFBQTs7QUFBQSxXQUFhRCxjQUFjLE1BQWQsVUFBZSxJQUFmLFNBQXdCQyxJQUF4QixFQUFiO0FBQUEsR0FBWixFQUF3RCxDQUFDRCxjQUFELENBQXhELENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB1c2VTY3JvbGxSZWxhdGl2ZSBmcm9tICcuL2ludGVybmFsL3VzZVNjcm9sbFJlbGF0aXZlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2Nyb2xsVXAoKTogKG9wdGlvbnM/OiB7IGRpc3BsYWNlbWVudDogbnVtYmVyIH0pID0+IHZvaWQge1xuICBjb25zdCBzY3JvbGxSZWxhdGl2ZSA9IHVzZVNjcm9sbFJlbGF0aXZlKCk7XG5cbiAgcmV0dXJuIHVzZUNhbGxiYWNrKCguLi5hcmdzKSA9PiBzY3JvbGxSZWxhdGl2ZSgndXAnLCAuLi5hcmdzKSwgW3Njcm9sbFJlbGF0aXZlXSk7XG59XG4iXX0=